import { Modal, Button } from "antd";
import { ArrowLeftOutlined, LockOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import styles from "./loginRequiredModal.module.scss";

// وقتی کاربر مهمان می‌خواهد شماره‌ای را رزرو/شروع مزایده کند، به‌جای هدایت ناگهانی به صفحه ورود،
// اول موضوع را برایش توضیح می‌دهیم و اجازه می‌دهیم خودش تصمیم بگیرد؛ نتیجه‌ی جستجویش هم از دست نمی‌رود.
const LoginRequiredModal = ({ open, title = "", callback }) => {
	const handleCancel = (state = false) => {
		callback(state);
	};

	return (
		<Modal onCancel={() => handleCancel(false)} width="28.5rem" centered open={open} footer={null} className={styles.modal} destroyOnClose>
			<div className={styles.content}>
				<div className={styles.iconWrap}>
					<LockOutlined />
				</div>
				<h2>یک قدم تا شروع مزایده</h2>
				<p>
					برای شروع مزایده شماره <strong dir="ltr">{title}</strong> وارد حساب کاربری‌ شو یا ثبت‌نام کن.
				</p>
				<div className={styles.returnNote}>
					<SafetyCertificateOutlined />
					<span>الگو و شماره انتخابی‌ حفظ می‌شود و بعد از ورود، دقیقاً به همین مرحله برمی‌گردی.</span>
				</div>
				<div className={styles.actions}>
					<Button onClick={() => handleCancel(false)}>فعلاً نه</Button>
					<Button onClick={() => handleCancel(true)} className="btn-aptel">
						ورود یا ثبت‌نام <ArrowLeftOutlined />
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default LoginRequiredModal;
